var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"page"},[_c('Headline',{attrs:{"title":_vm.headlineText,"icon":"mdi-label-percent-outline"}}),(_vm.$store.state.condAdmin.conditionList != null)?_c('router-view',{on:{"setPageMode":_vm.setPageMode,"cancel":function($event){_vm.headlineText = _vm.$t('condAdmin.conditionList.headline')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }